export default __webpack_public_path__ + "static/media/car.f1f20733.svg";